<h1 mat-dialog-title>Hochgeladene Pass-PDFs</h1>

<div mat-dialog-content>
    <kiene-gruppe-tier-pass-scan-verwaltung [gruppe]="gruppe" (tiereUpdated)="onTiereUpdated()"></kiene-gruppe-tier-pass-scan-verwaltung>
</div>

<div mat-dialog-actions>
    <button mat-flat-button color="accent" (click)="dialogRef.close(tiereWereUpdated)">Schlie&szlig;en</button>
</div>
